import React from 'react';
import {
  Box,
  Grid,
  IconButton,
  TextField,
  Tooltip
} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useStudio } from '../../Context/StudioContext';


const ProgrammeSchedule = () => {
  const { formData, setFormData } = useStudio();

  const handleProgrammeChange = (index, field, value) => {
    const updated = [...formData.programmes];
    updated[index][field] = value;
    setFormData(prev => ({ ...prev, programmes: updated }));
  };

  const addProgramme = () => {
    setFormData(prev => ({
      ...prev,
      programmes: [...prev.programmes, { time: '', activity: '' }]
    }));
  };

  const removeProgramme = (index) => {
    const updated = [...formData.programmes];
    updated.splice(index, 1);
    setFormData(prev => ({ ...prev, programmes: updated }));
  };

  return (
    <Box
      sx={{
        width: '100%',
        mt:1
      }}
    >
      {formData.programmes.map((prog, index) => (
        <Grid
          container
          key={index}
          spacing={1}
          alignItems="center"
          sx={{ mb: 1 }}
        >
          <Grid item>
            <Tooltip title="Remove this row">
              <IconButton
                onClick={() => removeProgramme(index)}
                size="small"
                disabled={formData.programmes.length === 1}
                sx={{ color: '#d32f2f' }}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          </Grid>

          <Grid item>
            <TextField
              value={prog.time}
              type='time'
              onChange={(e) => handleProgrammeChange(index, 'time', e.target.value)}
              size="small"
            />
          </Grid>

          <Grid item xs>
            <TextField
              fullWidth
              value={prog.activity}
              onChange={(e) => handleProgrammeChange(index, 'activity', e.target.value)}
              placeholder="Program"
              size="small"
            />
          </Grid>
        </Grid>
      ))}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Tooltip title="Add new row">
          <IconButton size='small' onClick={addProgramme} color="primary">
            <AddCircleOutlineIcon/>
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default ProgrammeSchedule;
